import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentcolor",
  d: "M4 12a8 8 0 1 1 8 8 1 1 0 1 0 0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12a9.97 9.97 0 0 0 2.778 6.917 1 1 0 0 0 1.355.082l1.5-1.224a1 1 0 1 0-1.266-1.55l-.743.608A7.96 7.96 0 0 1 4 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentcolor",
  d: "M11 9a1 1 0 1 1 2 0v2.588l1.827 1.826a1 1 0 0 1-1.414 1.414l-2.122-2.12a1 1 0 0 1-.29-.776z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }